import { Directive, HostListener } from '@angular/core';
import { NotificacionesService } from '../services/notificaciones.service';

@Directive({
  selector: '[appBlockCopyPaste]'
})
export class BlockCopyPasteDirective {
  constructor(private alert: NotificacionesService) { }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
    this.alert.warning('No se permite pegar en este control', true);
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
    this.alert.warning('No se permite copiar en este control', true);
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
    this.alert.warning('No se permite cortar en este control', true);
  }

}